import { render, staticRenderFns } from "./Repay.vue?vue&type=template&id=5b0c785e&scoped=true&"
import script from "./Repay.vue?vue&type=script&lang=js&"
export * from "./Repay.vue?vue&type=script&lang=js&"
import style0 from "./Repay.vue?vue&type=style&index=0&id=5b0c785e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c785e",
  null
  
)

export default component.exports